import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core';
import EquipmentIcon from 'components/icons/equipmentIcon';
import { useTranslation } from 'react-i18next';

const styles = {
    root: {
        border: "1px solid rgba(224, 224, 224, 1)",
        minHeight: "300px",
        height: "300px",
        backgroundColor: "rgba(242, 242, 242, 1)",
    },
    innerTd: {
        width: "25%",
        textAlign: "center",
        color: "gray"
    },
};

const useStyles = makeStyles(styles);


export default function EmptyAsset(props) {
    const { ...rest } = props;
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <TableRow className={classes.root} {...rest}>
            <TableCell scope="row" className={classes.innerTd}>
                <EquipmentIcon />
                <div>
                {t('noEquipment')}
                </div>
            </TableCell>
        </TableRow>
    );
}
